import { useEffect, useState } from "react";
import { Catalog, loadCatalog } from "../lib/catalog";
import { Entity, VideoThumbnail } from "../types/cms";

export type { Entity, Video, VideoThumbnail } from "../types/cms";

/**
 * Videos joined with their brand and studio.
 * `scope: "admin"` includes drafts (requires admin rights in Firestore rules).
 */
export const useVideosWithEntities = (scope: "public" | "admin" = "public") => {
  const [videos, setVideos] = useState<VideoThumbnail[]>([]);
  const [companies, setCompanies] = useState<Entity[]>([]);
  const [agencies, setAgencies] = useState<Entity[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<unknown>(null);
  const [version, setVersion] = useState(0);

  useEffect(() => {
    let active = true;
    setLoading(true);
    loadCatalog(scope, version > 0)
      .then((catalog: Catalog) => {
        if (!active) return;
        setVideos(catalog.videos);
        setCompanies(catalog.companies);
        setAgencies(catalog.agencies);
        setError(null);
      })
      .catch((err) => {
        console.error("Error fetching videos with entities:", err);
        if (active) setError(err);
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, [scope, version]);

  return {
    videos,
    setVideos,
    companies,
    agencies,
    loading,
    error,
    refetch: () => setVersion((v) => v + 1),
  };
};
